// extracted by mini-css-extract-plugin
module.exports = {"brand-modal__disclaimer":"brand-modal__disclaimer--9t7v6"};